<script lang="ts">
    import Link from "svelte-link";
    import FeatherIcon from "svelte-feather-icon";
    import { searchToggle ,searchValue,searchResult,isSearchVisible,isOpen} from "../../store";
    import { href } from "../../utils/Constant/Constant";
    let setsearchToggle:boolean;
    searchToggle.subscribe((value) => {
        setsearchToggle = value;
    });
    let setSearchValue:string;
    searchValue.subscribe((value) => {
        setSearchValue = value;
    });
    let setSearchResult:any;
    searchResult.subscribe((value) => {
        setSearchResult = value;
    });
    export let searchBar:boolean;
    export let setBookmarkItems;
    export let bookmarkItems;
    const addToBookmark = (event, items) => {
      const index = bookmarkItems.indexOf(items);
      if (index === -1 && !items.bookmark) {
          items.bookmark = true;
          event.currentTarget.classList.add("starred");
          setBookmarkItems([...bookmarkItems, items]);
      } else {
          event.currentTarget.classList.remove("starred");
          bookmarkItems.splice(index, 1);
          setBookmarkItems(bookmarkItems);
          items.bookmark = false;
      }
    };
    export const removeFix = () => {
      searchValue.update(value => value = "");
      searchToggle.update(value => value = false)
      isSearchVisible.update(value => value = false)
    };
    let setIsopen:boolean;
    isOpen.subscribe((value) => {
        setIsopen = value;
    });
</script>
<div
  class={`Typeahead-menu ${searchBar ? `custom-scrollbar ${setsearchToggle ? "is-open" : ""}` : `filled-bookmark  ${setIsopen ? "is-open" : ""}custom-scrollbar` } `} id="search-outer"
>  {#if setSearchValue && setSearchResult}
    {#each setSearchResult as selectItem}
      <div class="ProfileCard u-cf">
        {#if !searchBar}
          <div class="ProfileCard-avatar">
            <FeatherIcon icon={selectItem.icon} />
          </div>
        {/if}
        <div class="ProfileCard-details">
          <div class="ProfileCard-realName">
            <Link
              href={selectItem.path}
              class="realname w-100 d-flex align-items-center justify-content-start gap-2"
              on:click={removeFix}
            >
              {#if searchBar}
                <FeatherIcon icon={selectItem.icon} />
              {/if}
              <h6 class="select-item">{selectItem.title}</h6>
            </Link>
            {#if !searchBar}
              <span class="pull-right">
                <a href={href}>
                  <!-- svelte-ignore a11y-click-events-have-key-events -->
                  <i
                    class="fa fa-star-o mt-1 icon-star"
                    on:click={(e, data) => addToBookmark(e, data)}
                  />
                </a>
              </span>
            {/if}
          </div>
        </div>
      </div>
    {/each}
  {/if}
</div>